import { Steps, StepStatus } from "@/constants/analysis-status/index";

export class AnalysisStatus {
  public uuid!: string;

  public year!: string;

  public status!: string;

  public step!: string;

  public message!: string;

  get finishedWithSuccess(): boolean {
    return this.step === Steps.SUMMARY && this.status === StepStatus.FINISHED;
  }

  get finishedWithError(): boolean {
    return this.status === StepStatus.ERROR;
  }

  get processing(): boolean {
    return this.status === StepStatus.PROCESSING;
  }

}
